import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { postJSON, getCSRFHeaders } from '@folklore/fetch';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { useFormComponent } from '@panneau/core/contexts';
import { useForm } from '@panneau/core/hooks';

var _excluded = ["action", "method", "type", "postForm", "postOptions", "postData", "fields", "value", "onChange", "onComplete", "submitButtonLabel", "useFormProps", "className"];
var propTypes = {
  action: PropTypes.string.isRequired,
  method: PropTypes.string,
  postForm: PropTypes.func,
  postOptions: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  postData: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  type: PropTypes.string,
  fields: PropTypes$1.fields.isRequired,
  value: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
  submitButtonLabel: PropTypes$1.label,
  useFormProps: PropTypes.shape({}),
  className: PropTypes.string
};
var defaultProps = {
  type: 'normal',
  method: null,
  postForm: null,
  postOptions: null,
  postData: null,
  value: null,
  onChange: null,
  onComplete: null,
  submitButtonLabel: null,
  useFormProps: null,
  className: null
};
var Form = function Form(_ref) {
  var action = _ref.action,
    method = _ref.method,
    type = _ref.type,
    postForm = _ref.postForm,
    postOptions = _ref.postOptions,
    postData = _ref.postData,
    providedFields = _ref.fields,
    providedValue = _ref.value,
    parentOnChange = _ref.onChange,
    onComplete = _ref.onComplete,
    submitButtonLabel = _ref.submitButtonLabel,
    useFormProps = _ref.useFormProps,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var FormComponent = useFormComponent(type);
  var defaultPostForm = useCallback(function (act, data) {
    return postJSON(act, postData !== null ? _objectSpread(_objectSpread({}, postData), data) : data, _objectSpread(_objectSpread({
      credentials: 'include',
      headers: getCSRFHeaders()
    }, method !== null ? {
      method: method
    } : null), postOptions !== null ? postOptions : null));
  }, [method, postOptions, postData]);
  var _useForm = useForm(_objectSpread({
      action: action,
      fields: providedFields,
      postForm: postForm || defaultPostForm,
      onComplete: onComplete,
      value: providedValue,
      setValue: parentOnChange
    }, useFormProps)),
    value = _useForm.value,
    setValue = _useForm.setValue,
    fields = _useForm.fields,
    onSubmit = _useForm.onSubmit,
    status = _useForm.status,
    generalError = _useForm.generalError,
    errors = _useForm.errors;
  return /*#__PURE__*/React.createElement(FormComponent, Object.assign({}, props, {
    action: action,
    method: "post",
    fields: fields,
    onSubmit: onSubmit,
    className: className,
    status: status,
    generalError: generalError,
    errors: errors,
    value: value,
    onChange: setValue,
    submitButtonLabel: submitButtonLabel || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "R1HYj0",
      defaultMessage: [{
        "type": 0,
        "value": "Save"
      }]
    })
  }));
};
Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

export { Form as default };
